<div class="prefill-form" *ngIf="prefillForm">
    <p class="text-muted small">
        {{
            (showPersonalFields
                ? 'company.employees.add-employee.prefill.hint'
                : 'company.employees.add-employee.prefill.shared-hint'
            ) | translate
        }}
    </p>

    <!-- <COPY FROM AN EMPLOYEE> -->
    <div class="copy-from" *ngIf="allEmployees && allEmployees.length">
        <label for="prefill-copy-from">{{
            'company.employees.add-employee.prefill.copy-from' | translate
        }}</label>
        <div class="d-flex align-items-center">
            <select
                class="form-control"
                id="prefill-copy-from"
                [(ngModel)]="copyFromEmployeeId"
            >
                <option [ngValue]="null">
                    {{
                        'company.employees.add-employee.prefill.copy-select'
                            | translate
                    }}
                </option>
                <option
                    *ngFor="let employee of allEmployees"
                    [ngValue]="employee.Id"
                >
                    {{ getEmployeeLabel(employee) }}
                </option>
            </select>
            <button
                type="button"
                class="btn btn-outline-primary ms-2 text-nowrap"
                [disabled]="!copyFromEmployeeId || isCopying"
                (click)="copyFromEmployee()"
            >
                {{
                    'company.employees.add-employee.prefill.copy-btn'
                        | translate
                }}
            </button>
        </div>
        <small class="text-muted">{{
            'company.employees.add-employee.prefill.copy-hint' | translate
        }}</small>
    </div>
    <!-- </COPY FROM AN EMPLOYEE> -->

    <form [formGroup]="prefillForm">
        <!-- <IDENTITY> -->
        <ng-container *ngIf="showPersonalFields">
            <h6 class="prefill-section">
                {{
                    'company.employees.add-employee.prefill.identity'
                        | translate
                }}
            </h6>
            <div class="row">
                <div class="form-group col-md-6">
                    <label for="prefill-firstname">{{
                        'shared.global-settings.first-name' | translate
                    }}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="prefill-firstname"
                        formControlName="FirstName"
                    />
                </div>
                <div class="form-group col-md-6">
                    <label for="prefill-lastname">{{
                        'shared.global-settings.last-name' | translate
                    }}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="prefill-lastname"
                        formControlName="LastName"
                    />
                </div>
                <div class="form-group col-md-6">
                    <label for="prefill-phone">{{
                        'shared.global-settings.phone' | translate
                    }}</label>
                    <input
                        type="tel"
                        class="form-control"
                        id="prefill-phone"
                        formControlName="PhoneNumber"
                    />
                </div>
                <div class="form-group col-md-6">
                    <label for="prefill-contactemail">{{
                        'shared.global-settings.email' | translate
                    }}</label>
                    <input
                        type="email"
                        class="form-control"
                        id="prefill-contactemail"
                        formControlName="ContactEmail"
                    />
                    <div
                        class="text-danger small"
                        *ngIf="prefillForm.controls['ContactEmail'].invalid"
                    >
                        {{
                            'company.employees.add-employee.prefill.invalid-email'
                                | translate
                        }}
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- </IDENTITY> -->

        <!-- <ORGANIZATION> -->
        <h6 class="prefill-section">
            {{
                'company.employees.add-employee.prefill.organization'
                    | translate
            }}
        </h6>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="prefill-role">{{
                    'company.employees.role' | translate
                }}</label>
                <select
                    class="form-control"
                    id="prefill-role"
                    formControlName="Role"
                >
                    <option [ngValue]="null">
                        {{
                            'shared.global-settings.unassigned-field'
                                | translate
                        }}
                    </option>
                    <option *ngFor="let role of allRoles" [ngValue]="role">
                        {{ 'db.roles.' + role | translate }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-manager">{{
                    'company.hierarchy.manager' | translate
                }}</label>
                <on-select-manager
                    id="prefill-manager"
                    formControlName="ManagerId"
                    [allEmployees]="allEmployees"
                >
                </on-select-manager>
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-category">{{
                    'shared.global-settings.category' | translate
                }}</label>
                <select
                    class="form-control"
                    id="prefill-category"
                    formControlName="EmployeeCategoryId"
                >
                    <option [ngValue]="null">
                        {{
                            'shared.global-settings.unassigned-field'
                                | translate
                        }}
                    </option>
                    <option
                        *ngFor="let category of employeeCategories$ | async"
                        [ngValue]="category.Id"
                    >
                        {{ category.Name }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-organizationunit">{{
                    'shared.global-settings.organization-unit' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-organizationunit"
                    formControlName="OrganizationUnit"
                />
            </div>
            <div class="form-group col-md-6" *ngIf="showPersonalFields">
                <label for="prefill-identifier">{{
                    'shared.global-settings.identifier' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-identifier"
                    formControlName="Identifier"
                />
            </div>
        </div>
        <!-- </ORGANIZATION> -->

        <!-- <ONEXPENSE SETTINGS> -->
        <h6 class="prefill-section">
            {{ 'company.employees.add-employee.prefill.on-params' | translate }}
        </h6>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="prefill-language">{{
                    'company.employees.add-employee.prefill.language'
                        | translate
                }}</label>
                <select
                    class="form-control"
                    id="prefill-language"
                    formControlName="LanguageCode"
                >
                    <option [ngValue]="null">
                        {{
                            'shared.global-settings.unassigned-field'
                                | translate
                        }}
                    </option>
                    <option
                        *ngFor="let language of allLanguages"
                        [ngValue]="language.code"
                    >
                        {{ language.name }}
                    </option>
                </select>
            </div>
        </div>
        <!-- </ONEXPENSE SETTINGS> -->

        <!-- <OTHER INFORMATIONS> -->
        <h6 class="prefill-section">
            {{
                'company.employees.add-employee.prefill.other-info' | translate
            }}
        </h6>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="prefill-otherinfo1">{{
                    'shared.global-settings.info1' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-otherinfo1"
                    formControlName="OtherInfo1"
                />
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-otherinfo2">{{
                    'shared.global-settings.info2' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-otherinfo2"
                    formControlName="OtherInfo2"
                />
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-otherinfo3">{{
                    'shared.global-settings.info3' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-otherinfo3"
                    formControlName="OtherInfo3"
                />
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-otherinfo4">{{
                    'shared.global-settings.info4' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-otherinfo4"
                    formControlName="OtherInfo4"
                />
            </div>
        </div>
        <!-- </OTHER INFORMATIONS> -->

        <!-- <ACCOUNTING> -->
        <h6 class="prefill-section">
            {{ 'shared.global-settings.accounting-params' | translate }}
        </h6>
        <div class="row">
            <div class="form-group col-md-6" *ngIf="showPersonalFields">
                <label for="prefill-thirdpartyaccount">{{
                    'shared.global-settings.info5' | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="prefill-thirdpartyaccount"
                    formControlName="ThirdPartyAccount"
                />
            </div>
            <div
                class="form-group col-md-6"
                *ngIf="(company$ | async)?.UseRestaurantTicket"
            >
                <label for="prefill-restaurant-ticket">{{
                    'shared.global-settings.has-restaurant-ticket' | translate
                }}</label>
                <select
                    class="form-control"
                    id="prefill-restaurant-ticket"
                    formControlName="HasRestaurantTicket"
                >
                    <option [ngValue]="null">
                        {{
                            'shared.global-settings.unassigned-field'
                                | translate
                        }}
                    </option>
                    <option [ngValue]="true">
                        {{
                            'company.employees.add-employee.prefill.yes'
                                | translate
                        }}
                    </option>
                    <option [ngValue]="false">
                        {{
                            'company.employees.add-employee.prefill.no'
                                | translate
                        }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-per-diem">{{
                    'shared.global-settings.has-per-diem' | translate
                }}</label>
                <select
                    class="form-control"
                    id="prefill-per-diem"
                    formControlName="HasPerDiem"
                >
                    <option [ngValue]="null">
                        {{
                            'shared.global-settings.unassigned-field'
                                | translate
                        }}
                    </option>
                    <option [ngValue]="true">
                        {{
                            'company.employees.add-employee.prefill.yes'
                                | translate
                        }}
                    </option>
                    <option [ngValue]="false">
                        {{
                            'company.employees.add-employee.prefill.no'
                                | translate
                        }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-6">
                <label for="prefill-pro-card">{{
                    'shared.global-settings.has-professional-card' | translate
                }}</label>
                <select
                    class="form-control"
                    id="prefill-pro-card"
                    formControlName="HasProfessionalCard"
                >
                    <option [ngValue]="null">
                        {{
                            'shared.global-settings.unassigned-field'
                                | translate
                        }}
                    </option>
                    <option [ngValue]="true">
                        {{
                            'company.employees.add-employee.prefill.yes'
                                | translate
                        }}
                    </option>
                    <option [ngValue]="false">
                        {{
                            'company.employees.add-employee.prefill.no'
                                | translate
                        }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div
                class="form-group col-md-6"
                *ngFor="let plan of accountingPlans$ | async"
            >
                <label>
                    {{ plan.Name }}
                    <select
                        class="form-control"
                        [ngModel]="selectedAccountingPlans[plan.Id]"
                        (ngModelChange)="
                            selectedAccountingPlans[plan.Id] = $event;
                            accountingPlanChanged()
                        "
                        [ngModelOptions]="{ standalone: true }"
                    >
                        <option [ngValue]="undefined">
                            {{
                                'shared.global-settings.unassigned-field'
                                    | translate
                            }}
                        </option>
                        <option
                            *ngFor="let value of plan.PossibleValues"
                            [ngValue]="value.Id"
                        >
                            {{ value.Name }}
                        </option>
                    </select>
                </label>
            </div>
        </div>
        <!-- </ACCOUNTING> -->

        <!-- <MILEAGE> -->
        <h6 class="prefill-section">
            {{ 'company.employees.add-employee.prefill.mileage' | translate }}
        </h6>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="prefill-mileageratio">{{
                    'company.employees.add-employee.prefill.mileage-ratio'
                        | translate
                }}</label>
                <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    id="prefill-mileageratio"
                    formControlName="MileageRatio"
                />
            </div>
            <div class="form-group col-md-6" *ngIf="showPersonalFields">
                <label for="prefill-distance">{{
                    'vehicles.distance-home-to-work' | translate
                }}</label>
                <input
                    type="number"
                    class="form-control"
                    id="prefill-distance"
                    formControlName="DistanceHomeToWork"
                />
            </div>
        </div>
        <!-- </MILEAGE> -->
    </form>
</div>
